<template>
    <div>
        <div class="vx-row">
            <div class="vx-col w-full xl:w-1/3 lg:w-1/2 md:w-1/2">
                <vx-card v-if="user" :title="$t('Data')" class="mb-base" id="page-user-view">
                    <table>
                        <tr>
                            <td class="font-semibold">{{$t("Name")}}</td>
                            <td>{{ user.name }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("LName")}}</td>
                            <td>{{ user.l_name }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("Email")}}</td>
                            <td>{{ user.email }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("PhoneNumber")}}</td>
                            <td>{{ user.phone }}</td>
                        </tr>
                        <tr v-if="rolesLoaded">
                            <td class="font-semibold">{{$t("Role")}}</td>
                            <td>{{ roles[user.group].name }}</td>
                        </tr>
                        <tr v-if="userTypesLoaded">
                            <td class="font-semibold">{{$t("UserType")}}</td>
                            <td>{{ userTypes[user.type].name }}</td>
                        </tr>
                    </table>

                    <vs-button class="mt-3 mr-6" color="primary" icon-pack="feather" icon="icon-edit" type="border" @click="editUserPrompt = true" >{{$t("Edit")}}</vs-button>

                </vx-card>
            </div>
            <div v-if="report" class="vx-col w-full xl:w-1/3 ls:w-1/2 md:w-1/2 mb-3">

                <vx-card :title="$t('TimeOverview')">

                    <!-- CHART -->
                    <template slot="no-body">
                        <div class="mt-3">
                            <vue-apex-charts
                                    type=radialBar
                                    height=240
                                    :options="overviewChartOptions"
                                    :series="overviewPercentageSeries" />
                        </div>
                    </template>

                    <!-- DATA -->
                    <div class="flex justify-between text-center mt-1" slot="no-body-bottom" v-if="report.needed_time">

                        <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0">
                            <p class="mt-4">{{$t('FinishedHours')}}</p>
                            <p class="mb-4 text-3xl font-semibold">{{report.total_time}}</p>
                        </div>
                        <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0">
                            <p class="mt-4">{{$t('HoursNeeded')}}</p>
                            <p class="mb-4 text-3xl font-semibold">{{report.needed_time.time}}</p>
                        </div>
                        <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0">
                            <p class="mt-4">{{$t('TotalDifferenceTillNow')}}</p>
                            <p class="mb-4 text-3xl font-semibold">{{report.total_time_difference}}</p>
                        </div>
                    </div>
                </vx-card>
            </div>
            <div v-if="vacation_allowances" class="vx-col w-full xl:w-1/3 ls:w-1/2 md:w-1/2 mb-3">
                <vx-card :title="$t('Vacations')">

                    <vs-table ref="allowanceTable" v-model="selectedAllowance" @selected="handleSelectedVacationAllowance" pagination :max-items="50" :data="vacation_allowances">

                        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between mb-3">

                            <div v-if="$checkPermission(407)" class="flex flex-wrap-reverse items-center">
                                <vs-button type="border" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addVacationAllowancePrompt = true">{{$t("Add")}}</vs-button>
                            </div>

                        </div>

                        <template slot="thead">
                            <vs-th sort-key="year">{{$t("Year")}}</vs-th>
                            <vs-th sort-key="allowance">{{$t("Days")}}</vs-th>
                            <vs-th sort-key="days_left">{{$t("DaysLeft")}}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <tbody>
                            <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                                <vs-td :data="data[index].year">
                                    {{ data[index].year }}
                                </vs-td>

                                <vs-td :data="data[index].allowance">
                                    {{ data[index].allowance }}
                                </vs-td>

                                <vs-td :data="data[index].days_left">
                                    {{ data[index].days_left }}
                                </vs-td>

                            </vs-tr>
                            </tbody>
                        </template>

                    </vs-table>

                    <vs-popup :title="$t('Add')" :active.sync="addVacationAllowancePrompt">
                        <div>
                            <p class="mt-6">{{$t("Year")}}</p>
                            <vs-input v-model="addAllowance['year']" style="width: 100%"/>
                            <p class="mt-6">{{$t("Days")}}</p>
                            <vs-input v-model="addAllowance['allowance']" style="width: 100%"/>
                            <vs-divider/>
                            <vs-button color="success" type="border" class="mt-6; mr-1" @click="addVacationAllowance">{{$t("Add")}}</vs-button>
                        </div>
                    </vs-popup>

                    <vs-popup :title="$t('Edit')" :active.sync="editVacationAllowancePrompt">
                        <div>
                            <p class="mt-6">{{$t("Year")}}</p>
                            <vs-input v-model="editAllowance['year']" style="width: 100%"/>
                            <p class="mt-6">{{$t("Days")}}</p>
                            <vs-input v-model="editAllowance['allowance']" style="width: 100%"/>
                            <vs-divider/>
                            <vs-button style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="editVacationAllowance">{{$t("Change")}}</vs-button>
                        </div>
                    </vs-popup>

                </vx-card>
            </div>

            <div v-if="time_edits" class="vx-col w-full xl:w-1/3 ls:w-1/2 md:w-1/2 mb-3">
                <vx-card :title="$t('TimeEdits')">

                    <vs-table ref="timeEditTable" v-model="selectedTimeEdit" @selected="handleSelectedTimeEdit" pagination :max-items="50" :data="time_edits">

                        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between mb-3">

                            <div v-if="$checkPermission(405)" class="flex flex-wrap-reverse items-center">
                                <vs-button type="border" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addTimeEditPrompt = true">{{$t("Add")}}</vs-button>
                            </div>

                        </div>

                        <template slot="thead">
                            <vs-th sort-key="date">{{$t("Date")}}</vs-th>
                            <vs-th sort-key="time">{{$t("Time")}}</vs-th>
                            <vs-th sort-key="comment">{{$t("Comment")}}</vs-th>
                            <vs-th sort-key="creator_user">{{$t("Adder")}}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <tbody>
                            <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                                <vs-td :data="data[index].date">
                                    {{ moment(data[index].date).format('DD/MM/YYYY')}}
                                </vs-td>

                                <vs-td :data="data[index].time">
                                    {{ data[index].time }}
                                </vs-td>

                                <vs-td :data="data[index].comment">
                                    {{ data[index].comment }}
                                </vs-td>

                                <vs-td :data="data[index].creator_user">
                                    {{ $store.getters.companyUsers[data[index].creator_user].name }}
                                </vs-td>

                            </vs-tr>
                            </tbody>
                        </template>

                    </vs-table>

                    <vs-popup :title="$t('Add')" :active.sync="addTimeEditPrompt">
                        <div>
                            <p class="mt-6">{{$t("Time")}}</p>
                            <vs-input v-model="addTimeEdit['time']" style="width: 100%"/>
                            <p class="mt-6">{{$t("Comment")}}</p>
                            <vs-input v-model="addTimeEdit['comment']" style="width: 100%"/>
                            <vs-divider/>
                            <vs-button color="success" type="border" class="mt-6; mr-1" @click="addTimeEditFunc">{{$t("Add")}}</vs-button>
                        </div>
                    </vs-popup>

                    <vs-popup :title="$t('Edit')" :active.sync="editTimeEditPrompt">
                        <div>
                            <p class="mt-6">{{$t("Time")}}</p>
                            <vs-input v-model="editTimeEdit['time']" style="width: 100%"/>
                            <p class="mt-6">{{$t("Comment")}}</p>
                            <vs-input v-model="editTimeEdit['comment']" style="width: 100%"/>
                            <vs-divider/>
                            <vs-button style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="saveTimeEdit">{{$t("Change")}}</vs-button>
                            <vs-button style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeTimeEdit">{{$t("Delete")}}</vs-button>
                        </div>
                    </vs-popup>

                </vx-card>
            </div>

            <div class="vx-col w-full xl:w-2/3 p-2">
                <absence-management-table :user-id="Number(this.$route.params.id)"/>
            </div>

        </div>

        <div class="vx-row mt-6">
            <div class="vx-col w-full">
                <user-vehicles-table :user-id="Number(this.$route.params.id)"/>
            </div>
        </div>

        <div class="vx-row mt-6">
            <div class="vx-col w-full">
                <user-analytics :user-id="Number(this.$route.params.id)"/>
            </div>
        </div>

        <vs-popup :title="$t('Edit')" :active.sync="editUserPrompt" v-if="userTypesLoaded && rolesLoaded && editUser">
            <div>
                <p class="mt-6">{{$t("Email")}}</p>
                <vs-input v-model="editUser['email']" style="width: 100%"/>
                <p class="mt-6">{{$t("Name")}}</p>
                <vs-input v-model="editUser['name']" style="width: 100%"/>
                <p class="mt-6">{{$t("LName")}}</p>
                <vs-input v-model="editUser['l_name']" style="width: 100%"/>
                <p class="mt-6">{{$t("PhoneNumber")}}</p>
                <vs-input v-model="editUser['phone']" style="width: 100%"/>
                <p class="mt-6">{{$t("RegistrationTerminalPIN")}}</p>
                <vs-input v-model="editUser['registration_terminal_pin']" style="width: 100%"/>
                <p class="mt-6">{{$t("RegistrationTerminalRFIDId")}}</p>
                <vs-input v-model="editUser['rfid']" style="width: 100%"/>
                <p class="mt-6">{{$t("Role")}}</p>
                <vs-select autocomplete style="width: 100%" class="selectExample" v-model="editUser['group']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in this.roles" />
                </vs-select>
                <p class="mt-6">{{$t("UserType")}}</p>
                <vs-select autocomplete style="width: 100%" class="selectExample" v-model="editUser['type']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in this.userTypes" />
                </vs-select>
                <vs-divider icon-pack="feather" icon="icon-lock" position="center" color="danger"/>
                <permissions v-if="roles[editUser['group']].permissions !== undefined" ref="addPermissions" :permissions="editUser['permissions']" :disabled-permissions="roles[editUser['group']].permissions"/>
                <vs-divider color="danger"/>
                <vs-button color="success" style="float: left" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="saveUser">{{$t("Save")}}</vs-button>
                <vs-button style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeUser">{{$t("Delete")}}</vs-button>
            </div>
        </vs-popup>
    </div>
</template>
<script>

    import AbsenceManagementTable from "./AbsenceManagementTable";
    import VueApexCharts from 'vue-apexcharts'
    import Permissions from "../Permissions";
    import UserAnalytics from "./UserAnalytics";
    import UserVehiclesTable from "./UserVehiclesTable";

    export default {
        components: {
            UserVehiclesTable,
            UserAnalytics,
            AbsenceManagementTable,
            VueApexCharts,
            Permissions
        },
        data() {
            return {
                user: undefined,

                roles: {},
                rolesLoaded: false,
                userTypes: {},
                userTypesLoaded: false,

                editUser: undefined,
                editUserPrompt: false,

                report: undefined,
                isMounted: false,

                vacation_allowances: undefined,
                selectedAllowance: {},
                addVacationAllowancePrompt: false,
                editVacationAllowancePrompt: false,

                addAllowance: {},
                editAllowance: {},

                time_edits: undefined,
                selectedTimeEdit: {},
                addTimeEditPrompt: false,
                editTimeEditPrompt: false,

                addTimeEdit: {},
                editTimeEdit: {},

                overviewChartOptions:{
                    plotOptions: {
                        radialBar: {
                            size: 110,
                            startAngle: -150,
                            endAngle: 150,
                            hollow: {
                                size: '77%',
                            },
                            track: {
                                background: "#bfc5cc",
                                strokeWidth: '50%',
                            },
                            dataLabels: {
                                name: {
                                    show: false
                                },
                                value: {
                                    offsetY: 18,
                                    color: '#99a2ac',
                                    fontSize: '4rem'
                                }
                            }
                        }
                    },
                    colors: ['#00db89'],
                    fill: {
                        type: 'gradient',
                        gradient: {
                            shade: 'dark',
                            type: 'horizontal',
                            shadeIntensity: 0.5,
                            gradientToColors: ['#00b5b5'],
                            inverseColors: true,
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [0, 100]
                        },
                    },
                    stroke: {
                        lineCap: 'round'
                    },
                    chart: {
                        sparkline: {
                            enabled: true,
                        },
                        dropShadow: {
                            enabled: true,
                            blur: 3,
                            left: 1,
                            top: 1,
                            opacity: 0.1
                        },
                    },
                },

                timesChartOptions: {
                    labels: [this.$t('Work'), this.$t('Transport'), this.$t('Absence')],
                    plotOptions: {
                        radialBar: {
                            size: 165,
                            offsetY: -5,
                            hollow: {
                                size: '25%'
                            },
                            track: {
                                background: "#ebebeb",
                                strokeWidth: '100%',
                                margin: 15,
                            },
                            dataLabels: {
                                show: true,
                                name: {
                                    fontSize: '18px',
                                },
                                value: {
                                    fontSize: '16px',
                                    color: "#636a71",
                                    offsetY: 11
                                },
                                total: {
                                    show: true,
                                    label: this.$t('Total'),
                                    formatter: this.getTotal,
                                }
                            }
                        },
                    },
                    responsive: [{
                        breakpoint: 576,
                        options: {
                            plotOptions: {
                                radialBar: {
                                    size: 150,
                                    hollow: {
                                        size: '20%'
                                    },
                                    track: {
                                        background: "#ebebeb",
                                        strokeWidth: '100%',
                                        margin: 15,
                                    },
                                }
                            }
                        }
                    }],
                    colors: ['#7961F9', '#FF9F43', '#EA5455'],
                    fill: {
                        type: 'gradient',
                        gradient: {
                            // enabled: true,
                            shade: 'dark',
                            type: 'vertical',
                            shadeIntensity: 0.5,
                            gradientToColors: ['#9c8cfc', '#FFC085', '#f29292'],
                            inverseColors: false,
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [0, 100]
                        },
                    },
                    stroke: {
                        lineCap: 'round'
                    },
                    chart: {
                        height: 355,
                        dropShadow: {
                            enabled: true,
                            blur: 3,
                            left: 1,
                            top: 1,
                            opacity: 0.1
                        },
                    }
                }
            }
        },
        watch: {
            editVacationAllowancePrompt: function () {
                if(!this.editVacationAllowancePrompt){
                    this.selectedAllowance = {}
                }
            },
            editTimeEditPrompt: function () {
                if(!this.editTimeEditPrompt){
                    this.selectedTimeEdit = {}
                }
            }
        },
        methods: {
            handleSelectedVacationAllowance(tr) {
                if(!this.$checkPermission(407)){
                    this.selectedAllowance = {};
                    return
                }
                this.editAllowance['year'] = tr.year;
                this.editAllowance['allowance'] = tr.allowance;
                this.editVacationAllowancePrompt = true;
            },
            handleSelectedTimeEdit(tr) {
                if(!this.$checkPermission(405)){
                    this.selectedTimeEdit = {};
                    return
                }
                this.editTimeEdit['time'] = tr.time;
                this.editTimeEdit['comment'] = tr.comment;
                this.editTimeEditPrompt = true;
            },
            addVacationAllowance() {
                const thisIns = this;
                this.$http.post('/api/v1/user/' + this.$route.params.id + "/vacation_allowance/", {
                    year: Number(thisIns.addAllowance['year']),
                    allowance: Number(thisIns.addAllowance['allowance']),
                }).then(function () {
                    thisIns.updateVacationAllowance();
                    thisIns.addVacationAllowancePrompt = false;
                    thisIns.addAllowance['year'] = "";
                    thisIns.addAllowance['allowance'] = "";
                }).catch(function (error) {
                    thisIns.addVacationAllowancePrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            editVacationAllowance() {
                const thisIns = this;
                this.$http.put('/api/v1/user/' + this.$route.params.id + "/vacation_allowance/" + this.selectedAllowance.id, {
                    year: Number(thisIns.editAllowance['year']),
                    allowance: Number(thisIns.editAllowance['allowance']),
                }).then(function () {
                    thisIns.updateVacationAllowance();
                    thisIns.editVacationAllowancePrompt = false;
                }).catch(function (error) {
                    thisIns.editVacationAllowancePrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            updateVacationAllowance() {

                const thisIns = this;
                this.$http.get('/api/v1/user/' + this.$route.params.id + "/vacation_allowance")
                    .then(function (response) {
                        thisIns.vacation_allowances = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });

            },
            addTimeEditFunc() {
                const thisIns = this;
                this.$http.post('/api/v1/user/' + this.$route.params.id + "/time_edit/", {
                    time: Number(thisIns.addTimeEdit['time']),
                    comment: thisIns.addTimeEdit['comment'],
                }).then(function () {
                    thisIns.updateTimeEdit();
                    thisIns.addTimeEditPrompt = false;
                    thisIns.addTimeEdit['time'] = "";
                    thisIns.addTimeEdit['comment'] = "";
                }).catch(function (error) {
                    thisIns.addTimeEditPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            saveTimeEdit() {
                const thisIns = this;
                this.$http.put('/api/v1/user/' + this.$route.params.id + "/time_edit/" + this.selectedTimeEdit.id, {
                    time: Number(thisIns.editTimeEdit['time']),
                    comment: thisIns.editTimeEdit['comment'],
                }).then(function () {
                    thisIns.updateTimeEdit();
                    thisIns.editTimeEditPrompt = false;
                }).catch(function (error) {
                    thisIns.editTimeEditPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeTimeEdit() {
                const thisIns = this;
                this.$http.delete('/api/v1/user/' + this.$route.params.id + "/time_edit/" + this.selectedTimeEdit.id).then(function () {
                    thisIns.updateTimeEdit();
                    thisIns.editTimeEditPrompt = false;
                }).catch(function (error) {
                    thisIns.editTimeEditPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            updateTimeEdit() {

                const thisIns = this;
                this.$http.get('/api/v1/user/' + this.$route.params.id + "/time_edit")
                    .then(function (response) {
                        thisIns.time_edits = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });

            },
            updateUser() {
                const thisIns = this;
                this.$http.get('/api/v1/user/' + this.$route.params.id)
                    .then(function (response) {
                        thisIns.user = response.data;
                        thisIns.editUser = JSON.parse(JSON.stringify(response.data));
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });

                this.updateVacationAllowance();
                this.updateTimeEdit();
            },
            getTotal() {
                return this.report.total_time
            },
            saveUser() {

                this.editUser['permissions'] = this.$refs.addPermissions.permissionArrayNoDisabled;

                const thisIns = this;
                this.$http.put('/api/v1/user/' + this.$route.params.id, this.editUser).then(function () {
                    thisIns.updateUser();
                    thisIns.editUserPrompt = false;
                }).catch(function (error) {
                    thisIns.editUserPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeUser(){
                const thisIns = this;
                this.$http.delete('/api/v1/user/' + this.$route.params.id)
                    .then(function () {
                        thisIns.editUserPrompt = false;
                        thisIns.$nextTick(() => {
                            thisIns.$router.push('/users')
                        });
                    }).catch(function (error) {
                    thisIns.editUserPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            }
        },
        computed: {
            currentPage() {
                if(this.isMounted) {
                    return this.$refs.allowanceTable.currentx
                }
                return 0
            },
            overviewPercentageSeries: function () {

                let data = [];

                if(this.report) {
                    data.push(Number(this.report.done_percentage));
                }
                return data;
            },
            typesPercentageSeries: function () {

                let data = [];

                if(this.report) {
                    data.push(this.report.time_percentage);
                    data.push(this.report.transport_percentage);
                    data.push(this.report.absence_percentage);

                    return data;
                }

                return [0,0,0];
            }
        },
        beforeCreate(){

            const thisIns = this;
            this.$http.get('/api/v1/group/')
                .then(function (response) {
                    for(let x = 0; x < response.data.length; x++){
                        thisIns.roles[response.data[x].id] = response.data[x]
                    }
                    thisIns.rolesLoaded = true;
                });

            this.$http.get('/api/v1/user_type/')
                .then(function (response) {
                    for(let x = 0; x < response.data.length; x++){
                        thisIns.userTypes[response.data[x].id] = response.data[x]
                    }
                    thisIns.userTypesLoaded = true;
                });

            this.$http.get('/api/v1/user/' + this.$route.params.id + '/report/')
                .then(function (response) {
                    thisIns.report = response.data;
                })
                .catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });

        },
        created() {
            this.updateUser()
        },
        mounted() {
            this.isMounted = true;
        },
    }
</script>
<style lang="scss">
    #page-user-view {
        table {
            td {
                vertical-align: top;
                min-width: 180px;
                padding-bottom: .8rem;
                word-break: break-all;
            }

            &:not(.permissions-table) {
                td {
                    @media screen and (max-width:370px) {
                        display: block;
                    }
                }
            }
        }
    }

    @media screen and (min-width:1201px) and (max-width:1211px),
    only screen and (min-width:636px) and (max-width:991px) {
        #account-info-col-1 {
            width: calc(100% - 12rem) !important;
        }

    }
</style>
